export default "__VITE_ASSET__Gs838Xlv__"